import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "../preguntasFrecuentes/Search";

export const Concesionarios = () => {
    const [concesionarias, setConcesionarias] = useState([]);
    const [query, setQuery] = useState("");

    useEffect(() => {
        fetch("/getConcesionarias")
            .then(res => res.json())
            .then(data => setConcesionarias(data));
    }, []);

    const filtered = query === ""
        ? concesionarias
        : concesionarias.filter(c => {
            const q = query.toLowerCase();
            return (
                (c.nombre && c.nombre.toLowerCase().includes(q)) ||
                (c.provincia && c.provincia.toLowerCase().includes(q)) ||
                (c.ciudad && c.ciudad.toLowerCase().includes(q))
            );
        });

    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={"/"}>Inicio</Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p className="ff-FuturaMedium">Listado de concesionarios</p>
                    </div>
                </div>
            </div>

            <div className="slideInfo">
                <div className="slideInfo--container">
                    <Search setQuestion={setQuery} type="text" />
                    <div className="slideInfo--title">
                        <p>CONCESIONARIOS</p>
                        <div className="separator--hor mt-half mb-octa"></div>
                    </div>

                    {filtered.length === 0 && concesionarias.length === 0 && (
                        <p>Cargando concesionarios...</p>
                    )}
                    {filtered.length === 0 && concesionarias.length > 0 && (
                        <p>No se encontraron concesionarios.</p>
                    )}

                    {filtered.length > 0 && (
                        <div className="table-responsive">
                            <table className="table table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Provincia</th>
                                        <th>Ciudad</th>
                                        <th>Dirección</th>
                                        <th>Código Postal</th>
                                        <th>Teléfono</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.map(c => (
                                        <tr key={c.id}>
                                            <td>{c.nombre}</td>
                                            <td>{c.provincia}</td>
                                            <td>{c.ciudad}</td>
                                            <td>{c.address}</td>
                                            <td>{c.codigo_postal}</td>
                                            <td>{c.telefono}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
